import { useAppDispatch } from "@/shared/lib/redux"
import { 
    openUserAccrualModal as openUserAccrualModalAction ,
    closeUserAccrualModal as closeUserAccrualModalAction
} from '../../model'

export const useUserAccrualModal = () => {
    const dispatch = useAppDispatch()

    const openUserAccrualModal = (user: { id: string }, onSuccess?: () => void) => {
        dispatch(openUserAccrualModalAction({
            data: user,
            onSuccess
        }))
    }

    const closeUserAccrualModal = () => {
        dispatch(closeUserAccrualModalAction())
    }
    
    return {
        openUserAccrualModal,
        closeUserAccrualModal
    }
}